<template>
  <div class="invoice">
    <div class="main_wrapper">
      <div>
        <div class="title">
          <!-- <i class="icon-license"></i> -->
          {{ $t('dashboard.invoice') }}
        </div>
      </div>
      <ul class="list">
        <li v-for="({paid_at, status, total, url}, index) in invoiceList" :key="index" class="item">
            <div>{{ paid_at }}</div>
            <div class="right-wrapper">
              <div v-if="status == 'paid'" class="success">{{ status }}</div>
              <div v-else class="open">{{ status }}</div>
              <div class="bold">{{ total }}</div>
              <a
              v-if="url"
              :href="url"
              class="current_color"
              ><i class="el-icon-download"></i
            ></a>
              <a
              v-else
              :href="url"
              class="color_gray"
              ><i class="el-icon-download"></i
            ></a>
            </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Invoice',
    props: {
      invoiceList: {
        type: Array,
        required: false
      }
    },
    data() {
      return {
      }
    },
    computed: {
      lang() {
        return this.$store.state.lang
      }
    },
    methods: {
      log(item) {
        console.log(item)
      }
    },
    mounted() {
    }
  }
</script>

<style lang="scss" scoped>
  .invoice {
    height: 100%;
    background: $white;
    @include border-radius(8px);
    padding: 24px 24px;
    font-size: 18px;
    position: relative;
    box-sizing: border-box;
    margin-bottom: 13px;
    border: $border;
    box-shadow: 1px 2px 4px hsla(210, 29%, 24%, 0.5);
  }
  .main_wrapper {
    display: flex;
    flex-direction: column;
    gap: 16px;
    /* justify-content: space-between; */
  }
  .title {
    font-family: NexaBold;
    .icon-license {
      font-size: 16px;
    }
  }
  .list {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  .item {
    display: flex;
    /* grid-template-columns: 1fr max-content 10%; */
    justify-content: space-between;
    align-items: center;
    padding: 16px 24px;
    border-radius: 8px;
    border: 1px solid hsl(210, 29%, 24%);
  }
  // todo: the right area can be aligned
  .right-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
  }
  .success {
    padding: 4px 8px;
    background-color: hsl(156, 50%, 50%);
    border: 1px solid hsl(210, 29%, 24%);
    border-radius: 8px;
  }
  .open {
    padding: 4px 8px;
    background-color: hsl(195, 53%, 79%);
    border: 1px solid hsl(240, 100%, 50%);
    border-radius: 8px;
  }
  .bold {
    font-weight: bold;
  }
  .color_gray {
    color: hsl(0, 0%, 80%);
    cursor: not-allowed;
  }
  .current_color {
    color: currentColor;
  }
  @media screen and (max-width: 450px) {
    .item {
      padding: 8px 16px;
      font-size: 14px;
    }
    .success {
    padding: 2px 4px;
  }
  .open {
    padding: 2px 4px;
  }
  }
</style>


// WEBPACK FOOTER //
// src/views/Dashboard/Invoice.vue